import React from "react";

import './Label.css';

import Col from "../../uiElements/grid/Col";
import Row from "../../uiElements/grid/Row";

const CardLable = ({
  onclick,
  name,
  condition,
  labelName
}) => (
    <Row>
        <Col className="mt-n5" >
                <label className="card-label">{name}</label>
              </Col>
              {condition!==null?(condition ? (
                <Col className="mt-n5 text-right">
                  {
                    <a href
                      onClick={onclick}
                      className="card-link"
                    >
                      {" "}
                      {labelName}{" "}
                    </a>
                  }
                </Col>):""):(<Col className="mt-n5 text-right">
                  {
                    <a href
                      onClick={onclick}
                      className="card-link"
                    >
                      {" "}
                      {labelName}{" "}
                    </a>
                  }
                </Col>)}
    </Row>
);


export default CardLable;
